"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationStore = void 0;
const mobx_1 = require("mobx");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Paths = __importStar(require("../constants/Paths"));
const path_1 = require("../helper/path");
class NavigationStore {
    navigationItems = [
        {
            description: 'navigation.dashboard.description',
            icon: Zupicons_1.default.dashboard,
            loginRequired: true,
            path: Paths.PATH_DASHBOARD,
            scope: [AuthorizationScopes_1.default.DASHBOARD],
            isMainNavItem: true,
            showShortCut: false,
            title: 'navigation.dashboard.title',
            url: Paths.PATH_DASHBOARD,
            uuid: 'f1c45828-d13b-4d70-8264-aa2f7fee8b44',
        },
        {
            description: 'navigation.shop.description',
            icon: Zupicons_1.default.shoppingCart,
            loginRequired: false,
            path: Paths.PATH_SHOP,
            scope: [AuthorizationScopes_1.default.SHOP_READ],
            isMainNavItem: true,
            showShortCut: true,
            title: 'navigation.shop.title',
            url: Paths.PATH_SHOP,
            uuid: 'c75fc7d4-a2d3-47fb-8063-828d01070980',
        },
        {
            description: 'navigation.order_history.description',
            icon: Zupicons_1.default.history,
            loginRequired: true,
            path: Paths.PATH_SHOP,
            scope: [AuthorizationScopes_1.default.ORDER_READ],
            isMainNavItem: false,
            showShortCut: true,
            title: 'navigation.order_history.title',
            url: Paths.PATH_USER_PROFILE_ORDERS,
            uuid: '5c2199d8-cc08-48ea-b2b1-116dc0873b14',
        },
        {
            description: 'navigation.reseller_area.description',
            hideForbidden: true,
            icon: Zupicons_1.default.chartNetwork,
            loginRequired: true,
            path: Paths.PATH_RESELLER,
            scope: [AuthorizationScopes_1.default.RESELLER_READ],
            isMainNavItem: true,
            showShortCut: false,
            title: 'navigation.reseller_area.title',
            url: Paths.PATH_RESELLER,
            uuid: 'f5d6cbeb-f92b-46d8-9818-7655a5b7fdaf',
        },
        {
            description: 'navigation.mydocuments.description',
            hideForbidden: true,
            icon: Zupicons_1.default.fileSearch,
            loginRequired: true,
            path: Paths.PATH_MY_DOCUMENTS,
            scope: [AuthorizationScopes_1.default.DOCUMENTS_READ],
            isMainNavItem: true,
            showShortCut: false,
            title: 'navigation.mydocuments.title',
            url: Paths.PATH_MY_DOCUMENTS,
            uuid: '0bdeb82a-c312-4831-9ee4-5d97c1e9ac83',
        },
        {
            description: 'navigation.iot.description',
            icon: Zupicons_1.default.analytics,
            loginRequired: true,
            path: Paths.PATH_IOT,
            scope: [AuthorizationScopes_1.default.CONNECT_READ],
            isMainNavItem: true,
            showShortCut: true,
            title: 'navigation.iot.title',
            url: Paths.PATH_IOT,
            uuid: 'a21965a8-72a7-42a9-b3d4-3ae85f627bd1',
        },
        {
            description: 'navigation.myassets.description',
            icon: Zupicons_1.default.warehouse,
            loginRequired: true,
            path: Paths.PATH_ASSETS_SOFTWARE,
            scope: [AuthorizationScopes_1.default.LICENSE_READ, AuthorizationScopes_1.default.MACHINE_READ, AuthorizationScopes_1.default.OFFER_READ],
            isMainNavItem: true,
            showShortCut: true,
            title: 'navigation.myassets.title',
            url: Paths.PATH_ASSETS_SOFTWARE,
            uuid: '4d97a496-91a1-43e8-81b6-e3596bb168be',
        },
        {
            description: 'navigation.software.description',
            icon: Zupicons_1.default.union,
            loginRequired: true,
            path: Paths.PATH_SOFTWARE,
            scope: [AuthorizationScopes_1.default.SOFTWARE_READ],
            isMainNavItem: true,
            showShortCut: true,
            title: 'navigation.software.title',
            url: Paths.PATH_SOFTWARE,
            uuid: 'e0980dd5-036f-43e8-abfc-fb41e05c45af',
        },
        {
            description: 'navigation.user.description',
            icon: Zupicons_1.default.user,
            loginRequired: false,
            path: Paths.PATH_USER_PROFILE_ACCOUNT,
            scope: [AuthorizationScopes_1.default.PROFILE_READ],
            isMainNavItem: true,
            showShortCut: false,
            title: 'navigation.user.title',
            url: Paths.PATH_USER_PROFILE_ACCOUNT,
            uuid: '12a82dfe-11cb-4a8f-bf58-30120bcd1ca2',
        },
    ];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            navigationItems: mobx_1.observable,
        });
    }
    get items() {
        return this.navigationItems
            .filter((item) => item.isMainNavItem)
            .map((item) => ({
            ...item,
            url: (0, path_1.localePath)(item.url),
        }));
    }
    get shortCuts() {
        return this.navigationItems
            .filter((item) => item.showShortCut &&
            (!item.loginRequired || item.scope.some((element) => AuthorizationStore_1.default.hasScope(element))))
            .map((item) => ({
            ...item,
            url: (0, path_1.localePath)(item.url),
        }));
    }
}
exports.NavigationStore = NavigationStore;
exports.default = new NavigationStore();
